// Lazy load function
const lazyLoad = (file) => () =>
    import(
      /* webpackChunkName: "[request]" */ `@/views/purchasing/intake-estimate/${file}.vue`
    );

export default [

    {
        path: "/intake-estimate",
        name: "intake-estimate",
        meta: { requiresAuth: true, applicationFeatureCode: "AlmondcoIntakeEstimate" },
        components: {
            content: lazyLoad('intake-estimate-list'),
        },
    },
    {
        path: "/intake-estimate/create",
        name: "intake-estimate-create",
        meta: { requiresAuth: true, applicationFeatureCode: "AlmondcoIntakeEstimate" },
        components: {
            content: lazyLoad('intake-estimate'),
        },
    },
    {
        path: "/intake-estimate/review/:id",
        name: "intake-estimate-review",
        meta: { requiresAuth: true, applicationFeatureCode: "AlmondcoIntakeEstimate" },
        components: {
            content: lazyLoad('intake-estimate'),
        },
    },
    {
        path: "/intake-estimate/edit/:id",
        name: "intake-estimate-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "AlmondcoIntakeEstimate" },
        components: {
            content: lazyLoad('intake-estimate'),
        },
    },
]